import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FacebookShareButton, FacebookShareCount, TwitterShareButton, PinterestShareButton} from 'react-share';
import {faFacebookF, faTwitter, faPinterestP} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './ShareButtons.scss';
const {SITE_URL} = process.env;

export default function ShareButtons(props) {
  return (
    <>
      {props.floating ? (
        <div className="social-share social-share-floating">
          <ShareButtonsList {...props} />
        </div>
      ) : (
        <>
          {props.shareText ? (
            <div className="social-share-copy d-flex align-items-center justify-content-center">
              <div className="social-share-text mb-2 mb-sm-0 mr-sm-2">Share on social:</div>
              <div className="social-share d-flex align-items-center justify-content-center">
                <ShareButtonsList {...props} noDescription />
              </div>
            </div>
          ) : (
            <div className={classNames('social-share d-flex align-items-center', props.alignment)}>
              <ShareButtonsList {...props} noDescription />
            </div>
          )}
        </>
      )}
    </>
  );
}

ShareButtons.defaultProps = {
  alignment: 'justify-content-center justify-content-lg-end'
};

export function ShareButtonsList({
  shareUrl = `${SITE_URL}masterclass/`,
  shareImg = 'https://cdn.foodrevolution.org/hhc/opengraph/hhc-open-graph-202107-masterclass-v3.jpg',
  facebookDescription = 'Did you know that up to 90% of heart disease can be prevented and even reversed? Watch the Healthy Heart Masterclass and get the LATEST research-backed breakthroughs, so you can take charge of your heart health today. Join here:',
  twitterDescription = 'Did you know that up to 90% of heart disease can be prevented and even reversed? Watch the #HealthyHeartMasterclass to get the LATEST research-backed breakthroughs, so you can take charge of your heart health today. Join here:',
  twitterHashtags = [''],
  pinterestDescription = 'Learn the four most dangerous heart health myths, plus TEN recent breakthroughs that can SLASH your risk of heart disease! Join renowned holistic cardiologist Dr. Mimi Guarneri and Food Revolution Network CEO Ocean Robbins for this completely FREE masterclass.',
  pinterestImg = 'https://cdn.foodrevolution.org/hhc/opengraph/hhc-open-graph-202107-masterclass-pinterest-v3.jpg',
  noDescription = false,
  ...props
}) {
  return (
    <>
      {noDescription ? null : (
        <div className="social-button">
          <div className="btn btn-social btn-social-share">Shares</div>
        </div>
      )}

      <FacebookShareButton className="social-button" url={shareUrl} quote={facebookDescription}>
        <div className="btn btn-social btn-social-facebook">
          <FontAwesomeIcon className="social-button-icon" icon={faFacebookF} />
          <span className="btn-social-description btn-social-description-facebook d-none d-md-inline">Facebook</span>
        </div>
      </FacebookShareButton>

      <TwitterShareButton
        className="social-button"
        url={shareUrl}
        via="afoodrevolution"
        hashtags={twitterHashtags}
        title={twitterDescription}
      >
        <div className="btn btn-social btn-social-twitter">
          <FontAwesomeIcon className="social-button-icon" icon={faTwitter} />
          <span className="btn-social-description btn-social-description-twitter d-none d-md-inline">Twitter</span>
        </div>
      </TwitterShareButton>

      <PinterestShareButton
        className="social-button"
        url={shareUrl}
        media={pinterestImg}
        description={pinterestDescription}
      >
        <div className="btn btn-social btn-social-pinterest">
          <FontAwesomeIcon className="social-button-icon" icon={faPinterestP} />
          <span className="btn-social-description btn-social-description-pinterest d-none d-md-inline">Pinterest</span>
        </div>
      </PinterestShareButton>
    </>
  );
}
